import React from "react";
import StandingTable from "../../shared/standingTable";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

export default function RiderStanding() {
  const location = useLocation();
  const params = Object.fromEntries(new URLSearchParams(location.search));

  const category =
    params.year <= 2023
      ? [
          {
            value: "aa",
            text: "Adult Amateur",
          },
          {
            value: "ao3-3",
            text: `Amateur Owner 3'3`,
          },
          {
            value: "ao3-6",
            text: `Amateur Owner 3'6`,
          },
          {
            value: "childrens",
            text: `Children's`,
          },
          {
            value: "developpro",
            text: `Developing Professional`,
          },
          {
            value: "handy",
            text: `Handy`,
          },
          {
            value: "junior3-3",
            text: `Junior 3'3`,
          },
          {
            value: "junior3-6",
            text: `Junior 3'6`,
          },
          {
            text: "Pony",
            value: "pony",
          },
          {
            text: "Professional",
            value: "pro",
          },
        ]
      : [
          {
            value: "aa",
            text: "Adult Amateur",
          },
          {
            value: "ao3-3",
            text: `Amateur Owner 3'3`,
          },
          {
            value: "ao3-6",
            text: `Amateur Owner 3'6`,
          },
          {
            value: "childrens",
            text: `Children's`,
          },
          {
            value: "developpro",
            text: `Developing Professional`,
          },

          {
            value: "junior3-3",
            text: `Junior 3'3`,
          },
          {
            value: "junior3-6",
            text: `Junior 3'6`,
          },
          {
            text: "Pony",
            value: "pony",
          },
          {
            text: "Professional",
            value: "pro",
          },
        ];

  const tableHeader = [
    {
      width: "10%",
      header: "Rank",
    },
    {
      width: "35%",
      header: "Rider",
    },
    {
      width: "15%",
      header: "Comp Count",
    },
    {
      width: "30%",
      header: "City, State",
    },
    {
      width: "10%",
      header: "Points",
    },
  ];

  return (
    <StandingTable category={category} tableHeader={tableHeader} type="rider" />
  );
}
